"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));
var _starFilled = _interopRequireDefault(require("@ingka/ssr-icon/paths/star-filled"));
var _starHalfFilled = _interopRequireDefault(require("@ingka/ssr-icon/paths/star-half-filled"));
var _starFilledSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/star-filled-small"));
var _starHalfFilledSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/star-half-filled-small"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ratingShared = require("@ingka/rating-shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Rating = _ref => {
  let {
    prefix,
    href,
    rating,
    maxRating,
    onClick,
    ariaLabel,
    label,
    small,
    className
  } = _ref;
  if (!rating && rating !== 0) return null;
  const baseClass = `${prefix}rating`;
  const starIconClass = `${baseClass}__star`;
  const starFilledSize = small ? _starFilledSmall.default : _starFilled.default;
  const starHalfFilledSize = small ? _starHalfFilledSmall.default : _starHalfFilled.default;
  const classes = (0, _classnames.default)(`${baseClass}`, small && `${baseClass}--small`, className);
  const ratings = (0, _ratingShared.getRating)(rating, maxRating);
  let RatingTag = onClick ? 'button' : 'span';
  if (href) {
    RatingTag = 'a';
  }
  return _react.default.createElement(RatingTag, {
    href: href,
    onClick: !href ? onClick : null,
    className: classes
  }, _react.default.createElement("span", {
    "aria-label": ariaLabel,
    role: "img"
  }, ratings.map((ratingType, i) => {
    switch (ratingType) {
      case _ratingShared.STAR_FILLED:
        return _react.default.createElement(_ssrIcon.default, {
          key: i + 'filled',
          prefix: prefix,
          paths: starFilledSize,
          className: `${starIconClass} ${starIconClass}--filled`
        });
      case _ratingShared.STAR_HALF:
        return _react.default.createElement(_ssrIcon.default, {
          key: i + 'half',
          prefix: prefix,
          paths: starHalfFilledSize,
          className: `${starIconClass} ${starIconClass}--half-filled`
        });
      default:
        return _react.default.createElement(_ssrIcon.default, {
          key: i + 'empty',
          prefix: prefix,
          paths: starFilledSize,
          className: `${starIconClass} ${starIconClass}--empty`
        });
    }
  })), label && _react.default.createElement("span", {
    className: `${baseClass}__label`
  }, label));
};
Rating.defaultProps = {
  prefix: '',
  maxRating: 5
};
Rating.displayName = 'Rating';
var _default = Rating;
exports.default = _default;